import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const schoolResourceEditApi = createAsyncThunk(
    'auth/schoolResources/edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.patch(apiRoutes.schoolProcessAction(`${data.id}`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const schoolResourceEditSlice = createSlice({
    name: 'schoolResource Edit',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(schoolResourceEditApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(schoolResourceEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(schoolResourceEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const schoolResourceEditReducer = schoolResourceEditSlice.reducer